import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { HelpersService } from 'src/app/services/helpers.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit{
  // localhost:4200?application=attendances-report&saml-token=_ae29446740ffca823cd68ba3f27d084ebd18e9bf77
  constructor(public helpersService: HelpersService,
              private router: Router,
              private activatedRoute: ActivatedRoute) {}
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params && params['saml-token'] && params.application) {
        console.log(params);
        console.log('localhost:4200?application=attendances-report&saml-token=_' + params['saml-token']);
        this.gestLoginAdfs(params['saml-token'], params.application);
      } else {
        this.helpersService.routeInit();
      }
    }) 
  }

  private gestLoginAdfs(samlToken: string, application: string) {
    this.helpersService.login(samlToken).subscribe(res => {
      this.helpersService.setIsLogged(true);
      switch(application) {
        case 'attendances-report': 
          this.helpersService.setUser({"roles":["ROLE_SUPERVISOR"]});
          break;
      }
      this.helpersService.routeInit();
    }, err => {
      this.helpersService.showError('Accesso non riuscito!');
      this.router.navigateByUrl('/login')
    })
  }
}
